import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchAppPhotosSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/get_app_photos_summary/`, {
    params: {
      patientId,
      trialId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

const useGetAppPhotosSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["app-photos-summary", patientId, trialId],
    queryFn: () => fetchAppPhotosSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetAppPhotosSummary;
